import { ControlType } from '../../../../shared/form-lib';
import TextInput from '../text-input/text_input';
import NumberInput from '../number-field/number';
import Email from '../email-field/email';
import Datetime from '../date-time/date-time';
import SelectMultiple from '../select_multiple/select_multiple';
import FileUpload from '../file_upload/file_upload';
import HeartRating from '../heart_rating/heart_rating';
import StarRating from '../star_rating/star_rating';
import SmileyRating from '../smiley/smiley';
import ScaleRating from '../scale-field/scale';
import CheckBox from '../checkboxes/checkboxes';
import Radio from '../radio-buttons/radio_buttons';
import SelectBasic from '../select_basic/single_basic';
import Country from '../country/country';

const TableAllowedFields = {
  [ControlType.TEXT_INPUT]: TextInput,
  [ControlType.SHORT_TEXT]: TextInput,
  [ControlType.NUMBER]: NumberInput,
  [ControlType.HEART_RATING]: HeartRating,
  [ControlType.EMAIL]: Email,
  [ControlType.DATETIME]: Datetime,
  [ControlType.SELECT_MULTIPLE]: SelectMultiple,
  [ControlType.FILE_UPLOAD]: FileUpload,
  [ControlType.STAR_RATING]: StarRating,
  [ControlType.SCALE_RATING]: ScaleRating,
  [ControlType.SMILEY_RATING]: SmileyRating,
  [ControlType.SELECT_BASIC]: SelectBasic,
  [ControlType.CHECKBOXES]: CheckBox,
  [ControlType.RADIO_BUTTONS]: Radio,
  [ControlType.COUNTRY]: Country,
};

export default TableAllowedFields;
